import { API_ENDPOINTS } from "../constants/apiEndpoints";
import axiosInstance from "../config/axiosInstance";

/**
 * Lấy danh sách liên hệ theo mã ngôn ngữ
 * @param {string} languageCode - Mã ngôn ngữ (vd: 'vi', 'en', 'jp')
 * @returns {Promise<Array>} - Danh sách các văn phòng liên hệ
 */
export const getContactsByLanguage = async (languageCode) => {
    try {
        const response = await axiosInstance.get(
            API_ENDPOINTS.CONTACTS.GET_BY_LANGUAGE(languageCode)
        );
        const data = response.data;

        if (data && data.success && Array.isArray(data.data)) {
            return data.data;
        }

        if (Array.isArray(data)) {
            return data;
        }

        if (data && Array.isArray(data.data)) {
            return data.data;
        }

        return [];
    } catch (error) {
        console.error("Lỗi khi lấy danh sách liên hệ:", error);
        throw error;
    }
};

export const getContacts = async (params) => {
    const response = await axiosInstance.get(API_ENDPOINTS.ADMIN.CONTACTS.GET_ALL, { params });
    return response.data;
};

export const getContactById = async (id) => {
    const response = await axiosInstance.get(API_ENDPOINTS.ADMIN.CONTACTS.GET_BY_ID(id));
    return response.data;
};

export const createContact = async (data) => {
    const response = await axiosInstance.post(API_ENDPOINTS.ADMIN.CONTACTS.CREATE, data);
    return response.data;
};

export const updateContact = async (id, data) => {
    const response = await axiosInstance.put(API_ENDPOINTS.ADMIN.CONTACTS.UPDATE(id), data);
    return response.data;
};

export const deleteContact = async (id) => {
    const response = await axiosInstance.delete(API_ENDPOINTS.ADMIN.CONTACTS.DELETE(id));
    return response.data;
};
